import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthShell from "@/components/AuthShell";
import { api } from "@/lib/api";
import { useAuth, errMsg } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import PasswordRules from "@/components/PasswordRules";

export default function Initialize() {
  const navigate = useNavigate();
  const { initialize } = useAuth();
  const [ok, setOk] = useState(null);
  const [form, setForm] = useState({ phone: "", first_name: "", last_name: "", store_number: "", password: "", confirm: "" });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get("/auth/init-status").then(({ data }) => {
      setOk(data.needs_init);
      if (!data.needs_init) navigate("/login");
    });
  }, [navigate]);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirm) return toast.error("Passwords do not match.");
    setLoading(true);
    try {
      await initialize({
        phone: form.phone, first_name: form.first_name, last_name: form.last_name,
        store_number: form.store_number, password: form.password,
      });
      toast.success("Platform initialized. Welcome, Manager!");
      navigate("/app");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  if (ok === null) return null;

  return (
    <AuthShell
      title="Set up The Spread"
      subtitle="You're the first user. This creates the founding Management account with full Admin, Podcast Creator, and Consumer access."
    >
      <form onSubmit={submit} className="space-y-4">
        <div className="grid grid-cols-2 gap-3">
          <div>
            <Label htmlFor="first">First name</Label>
            <Input id="first" data-testid="init-firstname" value={form.first_name} onChange={set("first_name")} className="mt-1.5 border-brand-line bg-white" />
          </div>
          <div>
            <Label htmlFor="last">Last name</Label>
            <Input id="last" data-testid="init-lastname" value={form.last_name} onChange={set("last_name")} className="mt-1.5 border-brand-line bg-white" />
          </div>
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <Label htmlFor="phone">Phone number</Label>
            <Input id="phone" data-testid="init-phone" value={form.phone} onChange={set("phone")} placeholder="10 digits" className="mt-1.5 border-brand-line bg-white" />
          </div>
          <div>
            <Label htmlFor="store">Store number</Label>
            <Input id="store" data-testid="init-store" value={form.store_number} onChange={set("store_number")} placeholder="e.g. 1024" className="mt-1.5 border-brand-line bg-white" />
          </div>
        </div>
        <div>
          <Label htmlFor="pw">Password</Label>
          <Input id="pw" data-testid="init-password" type="password" value={form.password} onChange={set("password")} className="mt-1.5 border-brand-line bg-white" />
        </div>
        <div>
          <Label htmlFor="cf">Confirm password</Label>
          <Input id="cf" data-testid="init-confirm" type="password" value={form.confirm} onChange={set("confirm")} className="mt-1.5 border-brand-line bg-white" />
        </div>
        <PasswordRules password={form.password} />
        <Button type="submit" data-testid="init-submit" disabled={loading} className="w-full rounded-full brand-btn h-11">
          {loading ? "Setting up..." : "Create founding account"}
        </Button>
      </form>
    </AuthShell>
  );
}
